import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetEconomicSheets from "services/recordSheets/useGetEconomicSheets";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import { SheetPage, SheetHero, SheetPill, SheetSection, SheetGrid, SheetField, formatText, formatDate, formatCurrency, formatBoolean } from "../SheetLayout";

const GastosAsistencial: React.FC = () => {
  const params = useParams<{ detailId: string; id: string }>();
  const sheetId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { getCareExpenses, dataEconomicSheet: d, loadingEconomicSheet, errorEconomicSheet } = useGetEconomicSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getCareExpenses(userId, prestacionId, sheetId); }, []);

  if (loadingEconomicSheet) return <section className="container"><LoaderMin /></section>;
  if (errorEconomicSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  return (
    <SheetPage>
      <SheetHero
        title="Gastos Asistencial"
        icon="heart"
        pills={<>
          <SheetPill label="Médico" value={formatText(d.MedicoResponsable)} />
          <SheetPill label="Pagado" value={formatBoolean(d.estaPagado)} />
        </>}
      />

      <SheetSection title="Detalle" icon="file-text">
        <SheetGrid>
          <SheetField label="Médico Responsable"      value={formatText(d.MedicoResponsable)} wide />
          <SheetField label="Pagado"                  value={formatBoolean(d.estaPagado)} />
          <SheetField label="Fecha Pago"              value={formatDate(d.fechaPago)} />
          <SheetField label="Neto"                    value={formatCurrency(d.neto)} />
          <SheetField label="Concepto"                value={formatText(d.tipoGastoGeneralDescripcion)} wide />
          <SheetField label="Fecha Traspaso a Banco"  value={formatDate(d.fechaTraspasoABanco)} />
        </SheetGrid>
      </SheetSection>
    </SheetPage>
  );
};

export default GastosAsistencial;
